// Shared render helpers for character creation steps

import { html } from 'lit';
import '../components/shared/option-card.js';

/**
 * @typedef {import('../components/views/create-character-view.js').EquipmentPackage} EquipmentPackage
 */

/**
 * Render equipment package radio cards.
 * @param {Array<EquipmentPackage>} packages
 * @param {string} selectedSlug
 * @param {string} radioName
 * @param {(slug: string) => void} onSelect
 * @param {((desc: string) => string)|null} [descriptionTransform]
 */
export function renderEquipmentPackages(packages, selectedSlug, radioName, onSelect, descriptionTransform = null) {
  return html`
    <div class="mb-4">
      <h6 class="mb-2 d-inline">Starting Equipment</h6>
      <span class="badge bg-primary ms-1">${selectedSlug ? 1 : 0} / 1</span>
      <div class="row g-2 mt-2">
        ${packages.map((/** @type {EquipmentPackage} */ pkg, /** @type {number} */ pkgIndex) => {
          const desc = descriptionTransform ? descriptionTransform(pkg.description || '') : pkg.description || '';
          return html`
            <div class="col-12 col-lg-6">
              <option-card
                name="${pkg.name}"
                slug="${pkg.slug}"
                description="${desc}"
                ?selected="${selectedSlug === pkg.slug}"
                ?recommended="${pkgIndex === 0}"
                input-type="radio"
                radio-group="${radioName}"
                @card-selected="${() => onSelect(pkg.slug)}"
              ></option-card>
            </div>
          `;
        })}
      </div>
    </div>
  `;
}
